import React from 'react';
import Image from '@plone/volto/components/theme/Image/Image';
import { flattenToAppURL } from '@plone/volto/helpers/Url/Url';
import config from '@plone/volto/registry';
import PropTypes from 'prop-types';

import DefaultImageSVG from '@plone/volto/components/manage/Blocks/Listing/default-image.svg';

/**
 * Renders a preview image for a catalog brain result item.
 *
 */
function ContentImage(props) {
  const {
    item,
    size = 'preview',
    alt,
    customField,
    'show-placeholder': placeholder = false,
    ...rest
  } = props;

  let src;

  const imageAlt = alt || item.alt || item.title || 'Image';

  // Suporte para item.image com escalas
  if (item?.image && typeof item.image === 'object') {
    if (
      item.image.scales &&
      item.image.scales[size] &&
      item.image.scales[size].download
    ) {
      src = item.image.scales[size].download;
    } else if (item.image.download) {
      src = item.image.download;
    } else {
      src = null;
    }
  } else if (item?.image_url) {
    src = item.image_url;
  } else if (customField) {
    const imageField = item.image_scales?.[customField]?.[0];
    const imageBasePath = imageField?.base_path || item['@id'];
    src = imageField?.scales?.[size]?.download
      ? flattenToAppURL(`${imageBasePath}/${imageField.scales[size].download}`)
      : imageField?.download
        ? flattenToAppURL(`${imageBasePath}/${imageField.download}`)
        : null;
  } else {
    src = item.image_field
      ? flattenToAppURL(`${item['@id']}/@@images/${item.image_field}/${size}`)
      : placeholder
        ? config.getComponent({
            name: 'DefaultImage',
            dependencies: ['listing', 'summary'],
          }).component || DefaultImageSVG
        : null;
  }

  return src ? <Image src={src} alt={imageAlt} {...rest} /> : null;
}

ContentImage.propTypes = {
  size: PropTypes.string,
  'show-placeholder': PropTypes.bool,
  customField: PropTypes.string,
  item: PropTypes.shape({
    '@id': PropTypes.string.isRequired,
    image_field: PropTypes.string,
    title: PropTypes.string.isRequired,
  }),
};

export default ContentImage;
